<template>
  <div class="bg-light d-flex align-items-center">
    <img src="../assets/PumpJackBWcropped.jpg" class="img-fluid icon">
    <div class="words">
    <strong>Peakview was originally founded in 2011 as Peakview Energy Company to generate oil and gas prospects.  In 2011, Peakview acquired assets in the Buck Peak field bolstering our role in the energy sector as both operator and driller.  Currently we are drilling to expand the Buck Peak field in Moffat County, Colorado.
    <br>
    <br>Peakview Operating Company is actively looking to increase its footprint in the industry through acquisition of existing production with offset opportunities.
    <br>
    <br>As always, we continue to engage our original sucessful model of developing conventional and unconventional prospects. These prospects primarily focus on repeatable oil production opportunities with additional oil and gas prospective pay zones.</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
strong{
  color:#404040;
  font-size: 1rem;
}
.words{
  padding: 1.5rem;
}
img{
  max-height: 60vh;
  padding: 1.5rem 0rem 1.5rem 1.5rem;
}
@media (min-width: 800px) {
  .icon{
    width: 50vw;
    height: 100%;
  }
}
@media (max-width: 800px) {
  .icon{
    width: 0vw;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue